const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";

export const isAndroid = /Android/i.test(ua);
export const isIOS = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && typeof document !== "undefined" && "ontouchend" in document);

// Copies a PNG; the blob promise is handed over synchronously so iOS keeps the tap "permission"
export async function copyPng(blobPromise) {
  if (!navigator.clipboard || !window.ClipboardItem) throw new Error("unsupported");
  const png = blobPromise.then((b) => (b.type === "image/png" ? b : new Blob([b], { type: "image/png" })));
  try {
    await navigator.clipboard.write([new window.ClipboardItem({ "image/png": png })]);
  } catch (e) {
    // some Android browsers only accept a ready Blob, not a promise
    if (e && e.name === "NotAllowedError") throw e;
    await navigator.clipboard.write([new window.ClipboardItem({ "image/png": await png })]);
  }
}

export function pngFile(blob, name) {
  return new File([blob], name, { type: "image/png" });
}

export const canShareFile = (file) => !!(navigator.canShare && navigator.share && navigator.canShare({ files: [file] }));

// Opens the phone's share menu (Instagram, WhatsApp, Salvar imagem…). Returns false if not available.
export async function sharePng(blob, name) {
  const file = pngFile(blob, name);
  if (!canShareFile(file)) return false;
  try {
    await navigator.share({ files: [file] });
  } catch (e) {
    if (e && e.name === "AbortError") return true;
    throw e;
  }
  return true;
}

export function downloadPng(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
